import { TaskStatus, TimeWindow } from '@weave/schema-gen-ts/dist/schemas/task-center/shared/v1/enums.pb';
import { createProvider } from '@frontend/store';

type DashboardWidgetState = {
  timeWindow: TimeWindow;
  status: TaskStatus;
  setTimeWindow: (timeWindow: TimeWindow) => void;
  setStatus: (status: TaskStatus) => void;
};

export const { Provider: DashboardWidgetProvider, useStore: useDashboardWidgetStore } =
  createProvider<DashboardWidgetState>()((set) => ({
    timeWindow: TimeWindow['TIME_WINDOW_TODAY'],
    status: TaskStatus.STATUS_TODO,
    setTimeWindow: (timeWindow) => set({ timeWindow }),
    setStatus: (status) => set({ status }),
  }));
